import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector     : 'clear-layout',
    templateUrl  : './clear.component.html',
    encapsulation: ViewEncapsulation.None
})
export class clearLayoutComponent implements OnDestroy
{
    private _unsubscribeClr: Subject<void> = new Subject();

    /**
     * Constructor
     */
    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeClr.next( );
        this._unsubscribeClr.complete();
    }
}
